import { Component, h, Element } from '@stencil/core';
import {iconName} from './types'
import { socialIcon } from "../../utils/utils";
@Component({
  tag: 'social-share-list',
  styleUrl: 'social-share-list.css',
  shadow: true,
})


export class SocialShareList {
  @Element() element: HTMLElement;

  private getIcons() {
    const _dom = this.element.querySelector("#socila-list-json") as HTMLElement
    const res = JSON.parse(_dom.innerText) as { url: string; icon: iconName; pic?: string }[] 
    return res
  }

  private getIcon(icon: iconName): string {
    return socialIcon(icon)
  }

  private handleMouseOver(pic: string | undefined, e: Event): void {
    if(!pic) return
    const dom = (e.currentTarget as HTMLElement).querySelector<HTMLElement>(".popup")
    dom.style.display = "block"
  }

  private handleMouseOut(pic: string | undefined, e: Event): void {
    if(!pic) return
    const dom = (e.currentTarget as HTMLElement).querySelector<HTMLElement>(".popup")
    dom.style.display = "none"
  }

  render() {
    return (
      <div class="social-medias">
        {this.getIcons().map(item => (
          <li
          onMouseOver={(e) => this.handleMouseOver(item.pic, e)}
          onMouseOut={(e) => this.handleMouseOut(item.pic, e)}
          >
            <a href={item.url} innerHTML={this.getIcon(item.icon)}></a>
            {item.pic && <div class="popup">
              <div class="er-code">
                <img class="dps" src="https://www1.djicdn.com/dps/4413ccaad4601bce612a1ca9bcfefb4f@1x.webp" />
              </div>
              <div class="triangle"></div>
            </div>}
          </li>
        ))}
      </div>
    );
  }
}
